// 9fbef606107a605d69c0edbcd8029e5d
import { getAPIConfig } from '@tcp/core/src/utils';
import { executeStatefulAPICall } from '../../handler';
import endpoints from '../../endpoints';

const addPickUpPersonApi = (storeid, payload) => {
  const { siteId: currentSiteId } = getAPIConfig();
  const siteId = `PLACE_${currentSiteId.toUpperCase()}`;
  const payloadData = {
    webService: endpoints.addPickUpPerson,
    header: {
      siteId,
    },
    body: { ...payload },
  };
  return executeStatefulAPICall(payloadData)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};

export default addPickUpPersonApi;
